import { render, staticRenderFns } from "./CompletedGames.vue?vue&type=template&id=363495f1&scoped=true&"
import script from "./CompletedGames.vue?vue&type=script&lang=js&"
export * from "./CompletedGames.vue?vue&type=script&lang=js&"
import style0 from "./CompletedGames.vue?vue&type=style&index=0&id=363495f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363495f1",
  null
  
)

export default component.exports